module.exports = __webpack_public_path__ + "img/builder-4.cd8ef733.webp";